import { render } from "./svg-icon.vue?vue&type=template&id=038df1e9&scoped=true&ts=true"
import script from "./svg-icon.vue?vue&type=script&lang=ts"
export * from "./svg-icon.vue?vue&type=script&lang=ts"

import "./svg-icon.vue?vue&type=style&index=0&id=038df1e9&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038df1e9"]])

export default __exports__